export const MONTH_NAMES = [
  'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
];
const ONE_DAY_IN_MS = 86.4e6; // 1000 * 60 * 60 * 24
const EPOCH = Date.UTC(1970, 0, 1);

export function getQuarterFromMonth(month) {
  return Math.ceil((month + 1) / 3);
}

export function standardFormat(date) {
  return `${date.getFullYear()} ${MONTH_NAMES[date.getMonth()]} ${date.getDate()}`;
}

export function epochDays(date) {
  const dateUtc = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
  return Math.floor(Math.abs(EPOCH - dateUtc) / ONE_DAY_IN_MS) * (date < EPOCH ? -1 : 1);
}

export function dateFromEpochDays(days) {
  const date = new Date(EPOCH);
  date.setUTCDate(date.getUTCDate() + days);
  return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
}
